(() => {
  const init = () => document.querySelectorAll('.wa-product-detail').forEach(root => {
    if (root.dataset.cartReady) return;
    root.dataset.cartReady = 'true';
    const form = root.querySelector('form.product-buy');
    const button = form?.querySelector('[name="add"]');
    const feedback = root.querySelector('[data-wa-product-feedback]');
    const status = root.querySelector('[data-wa-product-status]');
    if (!form || !button || !feedback || !status) return;
    let busy = false;
    const variantData = root.querySelector('[data-product-variants]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const selectedVariant = () => {
      const values = Array.from(root.querySelectorAll('.product-variants .variant-field')).map(field => field.querySelector('input:checked, select')?.value);
      return values.length ? variants.find(variant => variant.options.every((value,index) => value === values[index])) : variants[0];
    };
    const refreshAvailability = () => {
      const variant = selectedVariant();
      const available = variant ? variant.available : root.dataset.variantAvailable === 'true';
      button.disabled = busy || !available;
      button.classList.toggle('disabled', !available);
      button.setAttribute('aria-disabled', String(button.disabled));
      button.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      const payment = form.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = !available;
      if (variant) form.querySelector('input[name="id"]').value = variant.id;
    };
    root.addEventListener('change', refreshAvailability);
    refreshAvailability();
    const add = async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      refreshAvailability();
      if (busy || button.disabled || button.classList.contains('disabled') || button.classList.contains('selling-plan-error') || !form.reportValidity()) return;
      busy = true;
      const payload = new FormData(form);
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      feedback.hidden = false;
      status.textContent = 'Adding to your cart…';
      try {
        const response = await fetch(form.action + '.js', {method:'POST',body:payload,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'We couldn’t add this item. Please try again.');
        status.textContent = 'Added to your cart.';
        root.querySelector('[data-wa-product-cart-actions]').hidden = false;
        document.dispatchEvent(new CustomEvent('wa:cart-added', {detail:{product:result}}));
        try {
          const cartResponse = await fetch(root.dataset.cartJsonUrl, {headers:{Accept:'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.wa-header__cart-count').forEach(count => count.textContent = cart.item_count);
            document.querySelectorAll('[data-wa-cart-link]').forEach(link => link.setAttribute('aria-label', root.dataset.cartLabel.replace('__COUNT__',cart.item_count)));
          }
        } catch {}
      } catch (error) {
        status.textContent = error instanceof TypeError ? 'Connection problem. Please check your cart before trying again.' : error.message;
        root.querySelector('[data-wa-product-cart-actions]').hidden = false;
      } finally {
        busy = false;
        refreshAvailability();
        form.removeAttribute('aria-busy');
      }
    };
    button.addEventListener('click', add, true);
    form.addEventListener('submit', event => {
      if (!event.submitter || event.submitter === button) add(event);
    }, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
